import React, { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Loader2, Flag } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

const REASONS = [
  { key: "harassment", label: "Harassment" },
  { key: "spam", label: "Spam" },
  { key: "scam", label: "Scam" },
  { key: "inappropriate", label: "Inappropriate content" },
  { key: "hate", label: "Hate or abusive content" },
  { key: "other", label: "Other" },
];

export default function ReportContentDialog({ open, onOpenChange, type, id, username }) {
  const [reason, setReason] = useState("inappropriate");
  const [details, setDetails] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try {
      await api.post(`/${type === "post" ? "posts" : "stories"}/${id}/report`, { reason, details: details.trim() || null });
      toast.success("Thanks — our moderators will take a look.");
      setDetails("");
      onOpenChange(false);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally { setBusy(false); }
  };
  const label = type === "post" ? "post" : "story";
  return <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="z-[11001] max-w-md rounded-3xl">
      <DialogTitle className="flex items-center gap-2 font-heading text-lg font-extrabold text-slate-900 dark:text-white"><Flag className="h-4 w-4 text-pink-500" /> Report {label}{username ? ` by @${username}` : ""}</DialogTitle>
      <DialogDescription className="text-sm text-slate-500">Reports are confidential and are reviewed by Yaprio moderators.</DialogDescription>
      <div className="mt-3 space-y-2" role="radiogroup">{REASONS.map((r) => <label key={r.key} className={`flex cursor-pointer items-center gap-3 rounded-2xl border p-3 text-sm ${reason === r.key ? "border-pink-400 bg-pink-50 dark:border-pink-400/50 dark:bg-pink-500/10" : "border-slate-100 dark:border-white/10"}`}><input type="radio" name="content-report-reason" value={r.key} checked={reason === r.key} onChange={() => setReason(r.key)} className="h-4 w-4 accent-pink-500" /><span className="font-semibold text-slate-800 dark:text-slate-200">{r.label}</span></label>)}</div>
      <Textarea value={details} onChange={(e) => setDetails(e.target.value)} maxLength={1000} placeholder="Add more context (optional)" className="mt-3 min-h-24 rounded-2xl" />
      <DialogFooter className="mt-2"><Button variant="outline" onClick={() => onOpenChange(false)} className="rounded-full">Cancel</Button><Button onClick={submit} disabled={busy} className="rounded-full bg-pink-500 text-white hover:bg-pink-600">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Submit report"}</Button></DialogFooter>
    </DialogContent>
  </Dialog>;
}
